import { fitMapToZone } from 'features/Responder/features/Zones';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const SelectedZoneFocus = ({ zone, zones, focusKey = null }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !zone || focusKey == null) return;
    fitMapToZone(map, zone, zones);
    // Key fit behavior to explicit selection changes.
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusKey, map]);

  return null;
};

export default SelectedZoneFocus;


